import { ResponseWrapper, Pagination } from './response.wrapper';

export interface MockPathOpts {
   url: string;
   verb: string;
   id?: string;
   split?: string;
   body?: any;
   captured?: string[];
}

type MockFunction<T> = ( opts: MockPathOpts ) => T;

export interface MockPath<T> {
   path: string;
   verb: string;
   bypass?: boolean;
   type?: string;
   wrapper?: MockFunction<ResponseWrapper<T>>;
   messages?: MockFunction<ResponseWrapper['messages']>;
   response?: MockFunction<{ collection: T[] }>;
   collection?: MockFunction<T[]>;
}

export function MockPagination( pagination?: any ): Pagination {
   return {
      hash: pagination?.hash || 'mock-hash',
      page: pagination?.page || 1,
      total: pagination?.total || Math.ceil( Math.random() * 10 )
   };
}
